import { createSelector } from "reselect";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";
import { MapEntity } from "@mapmycustomers/shared/types/entity";
import { MapEntitiesSet } from "@mapmycustomers/shared/types/map";

import { RootState } from "@app/store/rootReducer";
import GeoPath from "@app/types/GeoPath";
import RulerPath from "@app/types/map/RulerPath";

const routeDetailsState = (state: RootState) => state.scene.route.routeDetails.map;

export const getRouteTool = createSelector(routeDetailsState, ({ tool }) => tool);

export const getRouteRulerPath = createSelector(
  routeDetailsState,
  (routeDetails): RulerPath => routeDetails.rulerPath
);

export const getRouteLasso = createSelector(routeDetailsState, ({ lasso }) => lasso);
export const getRouteLassoPaths = createSelector(getRouteLasso, ({ paths }): GeoPath[] => paths);
export const getRouteLassoPathsCount = createSelector(getRouteLassoPaths, (paths) => paths.length);
export const getRouteLassoAllowAdd = createSelector(getRouteLasso, ({ allowAdd }) => allowAdd);
export const getRouteLassoContainsClusters = createSelector(
  getRouteLasso,
  ({ containsClusters }) => containsClusters
);
export const isRouteLassoLoading = createSelector(getRouteLasso, ({ loading }) => loading);

export const getRouteSelected = createSelector(routeDetailsState, ({ selected }) => selected);
export const getRouteSelectedItems = createSelector(
  getRouteSelected,
  ({ items }): MapEntitiesSet => items
);
export const getRouteSelectedEntities = createSelector(
  getRouteSelected,
  ({ entities }): MapEntity[] => entities
);
export const getRouteSelectedRecordsCount = createSelector(
  getRouteSelectedItems,
  (items) => items.size
);
export const getRouteExcludedRecords = createSelector(
  getRouteSelected,
  ({ excluded }): MapEntitiesSet => excluded
);
export const getRouteIncludedRecords = createSelector(
  getRouteSelected,
  ({ included }): MapEntitiesSet => included
);
export const isRouteLassoMode = createSelector(getRouteTool, (tool) => tool === MapTool.LASSO);
